import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=355e9fc2&scoped=true"
import script from "./Step.vue?vue&type=script&lang=ts"
export * from "./Step.vue?vue&type=script&lang=ts"
import style0 from "./Step.vue?vue&type=style&index=0&id=355e9fc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e9fc2",
  null
  
)

export default component.exports